export default __webpack_public_path__ + "static/media/JeongSeopLee.42290cce.jpg";